import { upperFirst } from "lodash";

export function reasonCodeLabel(code: string): string {
  return upperFirst(code.toLowerCase().replaceAll("_", " "));
}

export function toTimestamp(date: Date): number {
  return date.getTime();
}
